
import 'components/datatable.tag'
import 'components/catalog-static.tag'
import 'modals/add-link-modal.tag'
riot.tag2('product-files', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" handlers="{handlers}" upload="{upload}" remove="{handlers.remove}" reorder="true">\n        <yield to="toolbar">\n          <div class="form-group" if="{checkPermission(&quot;files&quot;, &quot;0100&quot;)}">\n            <div class="input-group btn btn-primary btn-file">\n              <input name="files" onchange="{opts.upload}" type="file" multiple="multiple"><i class="fa fa-plus"></i> Загрузить\n            </div>\n            <button class="btn btn-default" name="link" onclick="{parent.addLink}" type="button"><i class="fa fa-plus"></i> Ссылку</button>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name=""><i class="fa fa-4x fa-file-o icon-file"><span class="icon-ext">{row.fileExt}</span></i>\n\n          </datatable-cell>\n          <datatable-cell name="">\n            <input class="form-control" value="{row.fileText}" onchange="{handlers.fileAltChange}">\n            <div class="help-block"><a href="{row.fileURL}" target="_blank">{row.fileName}</a></div>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', 'product-files .icon-file,[riot-tag="product-files"] .icon-file,[data-is="product-files"] .icon-file{ position: relative; } product-files .icon-ext,[riot-tag="product-files"] .icon-ext,[data-is="product-files"] .icon-ext{ position: absolute; font-size: 13px; font-weight: bold; right: 7px; bottom: 7px; }', '', function(opts) {
'use strict';

var self = this;
self.mixin('permissions');
self.items = [];

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.add = function () {};

self.cols = [{ name: '', value: 'Файл' }, { name: '', value: 'Текст' }];

self.handlers = {
    fileAltChange: function fileAltChange(e) {
        e.item.row.fileText = e.target.value;
    },
    remove: function remove(e) {
        var rows = self.tags['catalog-static'].tags.datatable.getSelectedRows();

        rows.forEach(function (row) {
            self.value.splice(self.value.indexOf(row), 1);
        });
    }

};

self.addLink = function (e) {
    modals.create('add-link-modal', {
        type: 'modal-primary',
        title: 'Добавить ссылку',
        submit: function submit() {
            self.value.push({
                fileText: this.item.name,
                fileURL: this.item.name,
                fileExt: 'http',
                fileName: this.item.name
            });
            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
            this.modalHide();
        }
    });
};
self.upload = function (e) {
    var formData = new FormData();
    var FilesItems = [];

    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file' + i, e.target.files[i], e.target.files[i].name);
        //items.push(e.target.files[i].name)
    }

    API.upload({
        section: opts.section,
        object: 'Files',
        count: e.target.files.length,
        data: formData,
        progress: function progress(e) {},
        success: function success(response) {
            FilesItems = response.items;
            self.value = self.value || [];

            if (FilesItems.length == 0) {
                popups.create({ title: 'Ошибка!', text: 'Данные файлы уже есть на сервере', style: 'popup-danger' });
            }
            FilesItems.forEach(function (i) {
                self.value.push({
                    fileText: i.name,
                    fileURL: i.url,
                    fileExt: i.ext,
                    fileName: i.file
                });
            });
            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);
            self.update();
        }
    });
};

self.on('updated', function () {
    self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
        self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
        var temp = self.tags['catalog-static'].value;
        self.rows = [];
        self.update();
        self.tags['catalog-static'].value = temp;
        self.tags['catalog-static'].items.forEach(function (item, sort) {
            item.sortIndex = sort;
        });
    });
});

self.on('update', function () {
    if ('name' in opts && opts.name !== '') self.root.name = opts.name;

    if ('value' in opts) self.value = opts.value || [];
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-files.tag